import { QUOTES } from '../../data/quotes'
import { MANTRAS } from '../../data/mantras'
import QuoteLight from '../base/QuoteLight'
import QuoteFullColour from '../base/QuoteFullColour'

interface InspirationSectionProps {
  toolKey: string
  categoryKey: string
}

export default function InspirationSection({ toolKey, categoryKey }: InspirationSectionProps) {
  const quotes = QUOTES[toolKey] ?? []
  const mantra = MANTRAS[categoryKey] ?? ''

  if (quotes.length === 0 && !mantra) return null

  return (
    <div data-testid="inspiration-content">
      {quotes.map((q, i) => (
        <QuoteLight key={i} text={q.text} author={q.author} />
      ))}
      {mantra && <QuoteFullColour text={mantra} />}
    </div>
  )
}
